import styled from "styled-components";

export const FormMaterialImpressoStyle = styled.form`
  .flex {
    margin-bottom: 18px;
  }

  .select-nome{
    margin-right: 40px;
    margin-top: 6px;
  }

  .substrato{
    display: flex;
    flex-direction: column;

    select{
      width: 90%;
      min-width: 200px;
      max-width: 350px;
    }
  }

  .quatro {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0px;

    .input-completo {
      width: 94%;
    }
  }

  .button + span {
    margin-left: 25px;
    cursor: pointer;
  }

  .tres {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0px;

    .input-completo {
      width: 94%;
    }
  }

  label {
    font-size: 14px;
    font-weight: 500;
  }

  .item {
    margin-bottom: 18px;
  }
  .column {
    display: flex;
    flex-direction: column;
  }

  .width-90 {
    width: 90%;

    div {
      max-width: 92%;
    }
  }

  .true-false {
    width: 300px;
  }

  .flex-check {
    display: flex;
    flex-wrap: wrap;

    div {
      display: flex;
      margin-top: 20px;
      align-items: baseline;
      width: 300px;

      label {
        font-size: 12px;
        margin-left: 10px;
      }
    }
  }

  .cifrao {
    position: relative;
    top: -28.5px;
  }

  .relative {
    position: relative;
    margin-right: 20px;
    width: max-content;
    span {
      position: absolute;
      top: -10px;
      right: -8px;
      font-size: 12px;
      cursor: pointer;
      color: red;
      font-weight: 600;
    }
  }

  .select-substrato{
    margin-top: 10px;
  }

  .files {
    display: flex;
    margin-top: 20px;
  }

  h5 {
    font-size: 16px;
    color: black;
    font-weight: 500;
  }
`;
